module.exports = __webpack_public_path__ + "img/motorway_8x1_z18.5204787a.svg";